import {
  WEB_SOCKET_CONNECTION_ERROR,
  TAX_COMPUTATION_ERROR,
  CREATE_SIGNATURE_ERROR,
  CLOSE_MODAL_WARNING,
  PAYMENT_ERROR,
  CYBERSOURCE_ERROR,
  TAX_SERVICE_UNAVAILABLE_ERROR,
} from 'containers/constants'

const errors = {
  [WEB_SOCKET_CONNECTION_ERROR]: {
    message: 'covert.error.mediator.message',
    cta1: 'covert.error.mediator.cta1',
    placeholder: 'covert.error.mediator.placeholder',
  },
  [TAX_COMPUTATION_ERROR]: {
    message: 'covert.error.taxation.message',
    cta1: 'covert.error.taxation.cta1',
    placeholder: 'covert.error.taxation.placeholder',
  },
  [TAX_SERVICE_UNAVAILABLE_ERROR]: {
    message: 'covert.error.taxation.serviceunavailable.message',
    cta1: 'covert.error.taxation.serviceunavailable.cta1',
    placeholder: 'covert.error.taxation.serviceunavailable.placeholder',
  },
  [CREATE_SIGNATURE_ERROR]: {
    message: 'covert.error.checkout.message',
    cta1: 'covert.error.checkout.cta1',
    placeholder: 'covert.error.checkout.placeholder',
  },
  [PAYMENT_ERROR]: {
    message: 'covert.error.payment.message',
    cta1: 'covert.error.payment.cta1',
    placeholder: 'covert.error.payment.placeholder',
  },
  [CYBERSOURCE_ERROR]: {
    message: 'covert.error.cybersource.message',
    cta1: 'covert.error.cybersource.cta1',
    placeholder: 'covert.error.cybersource.placeholder',
  },
  [CLOSE_MODAL_WARNING]: {
    message: 'covert.error.close.window.message',
    cta1: 'covert.error.close.window.cta1',
    cta2: 'covert.error.close.window.cta2',
    placeholder: 'covert.error.close.window.placeholder',
  },
}

export default errors



// WEBPACK FOOTER //
// ./src/config/errors.js